import {Component, Input} from "@angular/core";
import {AbstractFieldComponent} from "../_abstract/abstract-field.component";

@Component({
    selector: 'field-radio',
    templateUrl: './field-radio.component.html',
    styleUrls: [
        './field-radio.component.scss'
    ],
    standalone: false
})
export class FieldRadioComponent  extends AbstractFieldComponent {

  @Input() public variants: Array<any> = [];

}
